export function getSignErrorMessage(e: any, step: string): string {
    const msg = e instanceof Error ? e.message : String(e);
    const lower = msg.toLowerCase();

    if (lower.includes('required')) {
        return `${step} failed: Required public keys are missing.`;
    }

    const encodingHint =
        ' Please check the key format and the encoding selection.';

    if (lower.includes('base58')) {
        return (
            `${step} failed: Invalid Base58 key format detected.` +
            encodingHint
        );
    }

    if (lower.includes('base64')) {
        return (
            `${step} failed: Invalid Base64 key format detected.` +
            encodingHint
        );
    }

    if (lower.includes('hex')) {
        return (
            `${step} failed: Invalid Hex key format detected.` +
            encodingHint
        );
    }

    if (lower.includes('decode')) {
        return (
            `${step} failed: Unable to decode the key. ` +
            `The key may be corrupted or incorrectly formatted.`
        );
    }

    if (lower.includes('seed') && lower.includes('32')) {
        return `${step} failed: Check the format of your private key.`;
    }

    if (lower.includes('proof') && lower.includes('credential')) {
        return `${step} failed: One or more credentials or signatures are invalid or have been tampered with.`;
    }

    return (
        `${step} failed: Verification could not be completed. ` +
        `Please check keys, encoding, and presentation format.`
    );
}